import { createUseStyles } from 'react-jss'

import { mediumGrey } from '../../../styles/const/colors'

const useStyles = createUseStyles({
  list: {
    margin: 0,
    padding: 0
  },
  noDataMessage: {
    margin: '50px auto 0',
    color: mediumGrey,
    maxWidth: 700,
    textAlign: 'center'
  },
  loadMoreBtn: {
    display: 'block',
    margin: '8px auto 24px'
  }
})

export default useStyles
